import { render, staticRenderFns } from "./EditItemWorkspace.vue?vue&type=template&id=459dacd1"
import script from "./EditItemWorkspace.vue?vue&type=script&lang=js"
export * from "./EditItemWorkspace.vue?vue&type=script&lang=js"
import style0 from "./EditItemWorkspace.vue?vue&type=style&index=0&id=459dacd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports